export default __webpack_public_path__ + "static/partner6-0ae0b6086abe7be5f9f91ff24d73c1c0.png";